import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { debounce } from 'lodash';
export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    placeholder: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    labelVariant: {
      type: Boolean,
      default: false
    },
    tokenSeparators: {
      type: Array,
      default: () => ['\t', '\n']
    }
  },
  emits: ['search-clear', 'input', 'search-input', 'paste'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const valueToEmit = event => {
      return event ?? '';
    };
    const localValue = ref(props.value);
    // This event is for catching the data pasted on the search input
    // we are splitting the data by the token separators with regex to compare with the tokenSeparators and emit the array of tokens
    // This is implemented for acheving the copy paste of multiple search
    const onPaste = event => {
      const paste = event.clipboardData.getData('text');
      const tokens = paste.split(new RegExp(props.tokenSeparators.map(separator => separator.replace('/[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\^\\$\\|]/g', '\\$&')).join('|'))).map(token => token.trim());
      const parsedTokens = tokens.filter(token => token);
      localValue.value = parsedTokens.join(' ');
      if (parsedTokens.length === 1) {
        emit('search-input', parsedTokens, {
          isPasted: false
        });
      } else {
        emit('search-input', parsedTokens, {
          isPasted: true
        });
      }
    };
    const debounceWrapper = input => {
      if (!input) {
        localValue.value = '';
        setLoading(false);
      } else {
        setLoading(true);
        localValue.value = input;
      }
      if (localValue.value === '') {
        emit('search-input', localValue.value);
      } else {
        debouncedSearch();
      }
    };
    const debouncedSearch = debounce(() => {
      emit('search-input', localValue.value);
    }, 750);
    const setLoading = isLoading => {
      loading.value = isLoading;
    };
    const loading = ref(false);
    expose({
      loading,
      setLoading,
      localValue
    });
    return {
      __sfc: true,
      props,
      emit,
      valueToEmit,
      localValue,
      onPaste,
      debounceWrapper,
      debouncedSearch,
      setLoading,
      loading
    };
  }
});